<div class="toolbar layout-row layout-align-space-between-center">
  <app-bringoz-multi-select [label]="'Type' | translate"
                            [selectedValues]="selectedTypes"
                            [options]="typeOptions"
                            (onValueChange)="onTypeFilterChange($event)">
  </app-bringoz-multi-select>

  <bringoz-button type="tertiary"
                   size="fit"
                   [ngbTooltip]="'Table Columns' | translate"
                   openDelay="300"
                   triggers="hover"
                   container="body"
                   (onClick)="onOpenColumnSettings.emit($event)">
    <bringoz-icon iconName="settings-outline"></bringoz-icon>
  </bringoz-button>
</div>

<app-bringoz-data-table [uniqueId]="tableUniqueId"
                        [defaultWidths]="defaultWidths"
                        [items]="filteredItems"
                        [idField]="'rowId'"
                        [rowHeight]="rowHeight"
                        [resizable]="true">

  <ng-template tableHeader>
    <div class="th col-row text-ellipsis">{{ 'Row' | translate }}</div>
    <div class="th col-name text-ellipsis">{{ 'Name' | translate }}</div>
    <div class="th col-agent text-ellipsis" *ngIf="columns?.agent?.enabled">{{ 'Agent' | translate }}</div>
    <div class="th col-type text-ellipsis" *ngIf="columns?.type?.enabled">{{ 'Type' | translate }}</div>
    <div class="th col-timezone text-ellipsis" *ngIf="columns?.timezone?.enabled">{{ 'Time Zone' | translate }}</div>
    <div class="th col-program-type text-ellipsis" *ngIf="columns?.programType?.enabled">{{ 'Program Type' | translate }}</div>
    <div class="th col-branch-ids text-ellipsis" *ngIf="columns?.branchIds?.enabled">{{ 'Branch Ids' | translate }}</div>
    <div class="th col-service-area-ids text-ellipsis" *ngIf="columns?.serviceAreaIds?.enabled">{{ 'Service Area Ids' | translate }}</div>
    <div class="th col-date text-ellipsis" *ngIf="columns?.date?.enabled">{{ 'Date' | translate }}</div>
    <div class="th col-start-time text-ellipsis" *ngIf="columns?.startTime?.enabled">{{ 'Start Time' | translate }}</div>
    <div class="th col-end-time text-ellipsis" *ngIf="columns?.endTime?.enabled">{{ 'End Time' | translate }}</div>
    <div class="th col-freq text-ellipsis" *ngIf="columns?.freq?.enabled">{{ 'Freq' | translate }}</div>
    <div class="th col-recurring-start-date text-ellipsis" *ngIf="columns?.recurringStartDate?.enabled">{{ 'Recurring Start Date' | translate }}</div>
    <div class="th col-recurring-end-date text-ellipsis" *ngIf="columns?.recurringEndDate?.enabled">{{ 'Recurring End Date' | translate }}</div>
    <div class="th col-interval text-ellipsis" *ngIf="columns?.interval?.enabled">{{ 'Interval' | translate }}</div>
    <div class="th col-by-week-day text-ellipsis" *ngIf="columns?.byWeekDay?.enabled">{{ 'By Week Day' | translate }}</div>
    <div class="th col-absence-reason text-ellipsis" *ngIf="columns?.absenceReason?.enabled">{{ 'Absence Reason' | translate }}</div>
  </ng-template>

  <ng-template tableRow let-item>
    <div class="tr layout-row layout-align-start-center">

      <div class="td col-row text-ellipsis">{{ item.rowNumber }}</div>

      <div class="td col-name layout-row layout-align-start-center">
        <bringoz-icon *ngIf="item.hasErrors"
                      iconName="error-outline"
                      color="red-103"
                      [ngbTooltip]="errorsTooltip"
                      openDelay="300"
                      triggers="hover"
                      container="body">
        </bringoz-icon>
        <ng-template #errorsTooltip>
          <div class="layout-column">
            <span class="br-body-2" *ngFor="let error of item.errorsList">{{ error }}</span>
          </div>
        </ng-template>
        <span class="text-ellipsis flex" [ngbTooltip]="item.display.name" openDelay="300" triggers="hover" container="body">
          {{ item.display.name }}
        </span>
        <bringoz-button aria-label="Remove Row"
                        type="tertiary"
                        size="fit"
                        [ngbTooltip]="'Remove Row' | translate"
                        openDelay="300"
                        triggers="hover"
                        container="body"
                        (onClick)="onRemoveRow.emit(item)">
          <bringoz-icon iconName="close-circle-outline"></bringoz-icon>
        </bringoz-button>
      </div>

      <div class="td col-agent text-ellipsis" *ngIf="columns?.agent?.enabled" [ngbTooltip]="item.display.agent" openDelay="300" triggers="hover" container="body">
        {{ item.display.agent }}
      </div>

      <div class="td col-type text-ellipsis" *ngIf="columns?.type?.enabled">{{ item.display.type }}</div>

      <div class="td col-timezone text-ellipsis" *ngIf="columns?.timezone?.enabled" [ngbTooltip]="item.display.timezone" openDelay="300" triggers="hover" container="body">
        {{ item.display.timezone }}
      </div>

      <div class="td col-program-type text-ellipsis" *ngIf="columns?.programType?.enabled">{{ item.display.programType }}</div>

      <div class="td col-branch-ids" *ngIf="columns?.branchIds?.enabled">
        <app-bringoz-items-list-display [items]="item.display.branchIds" [maxItems]="2"></app-bringoz-items-list-display>
      </div>

      <div class="td col-service-area-ids" *ngIf="columns?.serviceAreaIds?.enabled">
        <app-bringoz-items-list-display [items]="item.display.serviceAreaIds" [maxItems]="2"></app-bringoz-items-list-display>
      </div>

      <div class="td col-date text-ellipsis" *ngIf="columns?.date?.enabled">{{ item.display.date }}</div>

      <div class="td col-start-time text-ellipsis" *ngIf="columns?.startTime?.enabled">{{ item.display.startTime }}</div>

      <div class="td col-end-time text-ellipsis" *ngIf="columns?.endTime?.enabled">{{ item.display.endTime }}</div>

      <div class="td col-freq text-ellipsis" *ngIf="columns?.freq?.enabled">{{ item.display.freq }}</div>

      <div class="td col-recurring-start-date text-ellipsis" *ngIf="columns?.recurringStartDate?.enabled">{{ item.display.recurringStartDate }}</div>

      <div class="td col-recurring-end-date text-ellipsis" *ngIf="columns?.recurringEndDate?.enabled">{{ item.display.recurringEndDate }}</div>

      <div class="td col-interval text-ellipsis" *ngIf="columns?.interval?.enabled">{{ item.display.interval }}</div>

      <div class="td col-by-week-day" *ngIf="columns?.byWeekDay?.enabled">
        <app-bringoz-items-list-display [items]="item.display.byWeekDay" [maxItems]="2"></app-bringoz-items-list-display>
      </div>

      <div class="td col-absence-reason text-ellipsis" *ngIf="columns?.absenceReason?.enabled" [ngbTooltip]="item.display.absenceReason" openDelay="300" triggers="hover" container="body">
        {{ item.display.absenceReason }}
      </div>

    </div>
  </ng-template>

  <app-empty-state tableEmptyState
                   src="assets/images/empty_state/empty_state_good.png"
                   [text]="emptyStateText">
  </app-empty-state>

</app-bringoz-data-table>
